const zeroPad = (num, pad) => {
    return String(num).padStart(pad, '0')
}

const isSameDay = (d1, d2) => {
    return (
        d1.getFullYear() === d2.getFullYear() &&
        d1.getMonth() === d2.getMonth() &&
        d1.getDate() === d2.getDate()
    )
}

export const parseTimestamp = (timestamp, format = '') => {
    if (!timestamp) return

    const date = timestamp.seconds
        ? new Date(timestamp.seconds * 1000)
        : timestamp

    if (format === 'HH:mm') {
        return `${zeroPad(date.getHours(), 2)}:${zeroPad(date.getMinutes(), 2)}`
    } else if (format === 'DD MMMM YYYY') {
        const options = { month: 'long', year: 'numeric', day: 'numeric' }
        return `${new Intl.DateTimeFormat('de-DE', options).format(date)}`
    } else if (format === 'DD.MM.YYYY') {
        const options = { month: '2-digit', year: 'numeric', day: '2-digit' }
        return `${new Intl.DateTimeFormat('de-DE', options).format(date)}`
    } else if (format === 'DD MMMM, HH:mm') {
        const options = { month: 'long', day: 'numeric' }
        return `${new Intl.DateTimeFormat('de-DE', options).format(
            date
        )}, ${zeroPad(date.getHours(), 2)}:${zeroPad(date.getMinutes(), 2)}`
    } else if (format === 'full') {
        return `${new Intl.DateTimeFormat('de-DE', { dateStyle: 'full'}).format(date)}`
    }

    return date
}

export const formatTimestamp = (date, timestamp) => {
    const timestampFormat = isSameDay(date, new Date()) ? 'HH:mm' : 'DD.MM.YYYY'
    const result = parseTimestamp(timestamp, timestampFormat)
    return timestampFormat === 'HH:mm' ? `Heute, ${result}` : result
}
